<template>
  <div class="crime-filters">
    <div class="flex items-center space-x-3">
      <label class="text-sm font-medium text-gray-700 whitespace-nowrap">
        Crime Types:
      </label>
      
      <div class="relative" ref="dropdown">
        <button
          @click="toggleDropdown"
          class="crime-filter-button flex items-center justify-between w-64 px-3 py-2 text-sm border border-gray-300 rounded-md bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
        >
          <span class="truncate">
            {{ selectedText }}
          </span>
          <svg 
            class="w-4 h-4 ml-2 transition-transform duration-200"
            :class="{ 'rotate-180': isOpen }"
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
          >
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
          </svg>
        </button>
        
        <div 
          v-show="isOpen"
          class="absolute z-50 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-auto"
        >
          <div class="p-2 border-b border-gray-200">
            <button
              @click="selectAll"
              class="w-full text-left px-2 py-1 text-sm text-blue-600 hover:bg-blue-50 rounded"
            >
              Select All
            </button>
            <button
              @click="clearAll"
              class="w-full text-left px-2 py-1 text-sm text-gray-600 hover:bg-gray-50 rounded"
            >
              Clear All
            </button>
          </div>
          
          <div class="py-1">
            <label
              v-for="crimeType in crimeTypes"
              :key="crimeType.value"
              class="flex items-center px-3 py-2 hover:bg-gray-50 cursor-pointer"
            >
              <input
                type="checkbox"
                :value="crimeType.value"
                v-model="selectedCrimeTypes"
                class="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
              >
              <span class="ml-2 text-sm text-gray-700">{{ crimeType.label }}</span>
            </label>
          </div>
        </div>
      </div>
      
      <!-- Selected count badge -->
      <div v-if="selectedCrimeTypes.length > 0" class="flex items-center">
        <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
          {{ selectedCrimeTypes.length }} selected
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CrimeFilters',
  
  props: {
    value: {
      type: Array,
      default: () => []
    },
    crimeTypes: {
      type: Array,
      required: true
    }
  },
  
  data() {
    return {
      isOpen: false,
      selectedCrimeTypes: [...this.value]
    }
  },
  
  computed: {
    selectedText() {
      if (this.selectedCrimeTypes.length === 0) {
        return 'Select crime types...';
      } else if (this.selectedCrimeTypes.length === 1) {
        const selected = this.crimeTypes.find(ct => ct.value === this.selectedCrimeTypes[0]);
        return selected ? selected.label : 'Unknown';
      } else if (this.selectedCrimeTypes.length === this.crimeTypes.length) {
        return 'All crime types';
      } else {
        return `${this.selectedCrimeTypes.length} crime types selected`;
      }
    }
  },
  
  watch: {
    value: {
      handler(newValue) {
        this.selectedCrimeTypes = [...newValue];
      },
      deep: true
    },
    
    selectedCrimeTypes: {
      handler(newValue) {
        this.$emit('input', [...newValue]);
      },
      deep: true
    }
  },
  
  mounted() {
    // Close dropdown when clicking outside
    document.addEventListener('click', this.handleClickOutside);
  },
  
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  
  methods: {
    toggleDropdown() {
      this.isOpen = !this.isOpen;
    },
    
    selectAll() {
      this.selectedCrimeTypes = this.crimeTypes.map(ct => ct.value);
    },
    
    clearAll() {
      this.selectedCrimeTypes = [];
    },
    
    handleClickOutside(event) {
      if (this.$refs.dropdown && !this.$refs.dropdown.contains(event.target)) {
        this.isOpen = false;
      }
    }
  }
}
</script>

<style scoped>
.crime-filter-button {
  transition: all 0.2s ease-in-out;
}

.crime-filter-button:hover {
  border-color: #9CA3AF;
}

.crime-filter-button:focus {
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

/* Custom scrollbar for dropdown */
.max-h-60::-webkit-scrollbar {
  width: 6px;
}

.max-h-60::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.max-h-60::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.max-h-60::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>